
  <!-- Paste the following into the <body> -->
  <video id="videojs" controls preload="auto" class="video-js vjs-fluid vjs-default-skin vjs-big-play-centered" controls preload="auto">

    <source src="https://videostreaming.cloudserverlatam.com:443/demo/demo/playlist.m3u8" type="application/x-mpegURL">
     <source src="rtmps://videostreaming.cloudserverlatam.com:443/demo/demo" type="application/flash">
      <p class="vjs-no-js">
    To view this video please enable JavaScript, and consider upgrading to a web browser that
    <a href="https://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a>
   </p>
  </video>

